export default __webpack_public_path__ + "locales/ru/Common.json?hash=e6fe1609a539af99703c86908ddf4985";